/* Cover My Plate · cycling headline word. An h1 with data-cycle="meet, show, shoot" swaps its last word through the
   list ("Made for the meet." → "Made for the show." ...). The full headline stays readable to screen readers, and
   with reduced motion the first word just stays. Used by sections/cx-landing.liquid and sections/cx-doors.liquid. */
(function () {
  'use strict';
  // The word box clips only top and bottom (so words slide in and out), never the sides: the italic display face leans
  // past its own width, and a side clip shaved the last letter. A small gap keeps the full stop clear of the lean.
  var CSS = '.cyc{display:inline-block;position:relative;vertical-align:bottom;box-sizing:content-box;padding:0;margin:0 .05em 0 0;clip-path:inset(-.1em -.6em -.14em -.4em);transition:width .5s cubic-bezier(.2,.8,.2,1)}' +
    '.cyc__w{display:inline-block;white-space:nowrap}' +
    '.cyc__w.is-out{animation:cycOut .4s cubic-bezier(.5,0,.5,1) both}' +
    '.cyc__w.is-in{animation:cycIn .55s cubic-bezier(.2,.8,.2,1) both}' +
    '@keyframes cycOut{to{transform:translateY(-55%);opacity:0}}' +
    '@keyframes cycIn{from{transform:translateY(55%);opacity:0}to{transform:none;opacity:1}}';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lastText(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = w.nextNode())) if (/\S/.test(n.nodeValue)) last = n;
    return last;
  }

  function setup(h) {
    if (h._cyc) return; h._cyc = 1;
    var words = (h.getAttribute('data-cycle') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var t = lastText(h); if (!t || words.length < 2) return;
    var m = t.nodeValue.match(/^([\s\S]*?)(\S+?)([.!]?)(\s*)$/); if (!m) return;
    var first = m[2];
    if (words[0].toLowerCase() !== first.toLowerCase()) words.unshift(first);
    h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
    var box = document.createElement('span'); box.className = 'cyc'; box.setAttribute('aria-hidden', 'true');
    var w = document.createElement('span'); w.className = 'cyc__w'; w.textContent = first; box.appendChild(w);
    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode(m[1])); frag.appendChild(box); frag.appendChild(document.createTextNode(m[3] + m[4]));
    t.parentNode.replaceChild(frag, t);
    if (reduce) return;
    // match the case the headline uses (the CSS may uppercase it anyway)
    var up = first === first.toUpperCase();
    words = words.map(function (x) { return up ? x.toUpperCase() : x; });
    var i = 0, on = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { on = es[0].isIntersecting; }).observe(h);
    var measure = function (txt) { var s = document.createElement('span'); s.className = 'cyc__w'; s.style.cssText = 'position:absolute;visibility:hidden'; s.textContent = txt; box.appendChild(s); var r = s.getBoundingClientRect().width; s.remove(); return r; };
    var step = function () {
      if (!on || document.hidden) { setTimeout(step, 1000); return; }
      i = (i + 1) % words.length;
      var next = words[i];
      box.style.width = box.getBoundingClientRect().width + 'px';
      w.classList.remove('is-in'); w.classList.add('is-out');
      setTimeout(function () {
        w.textContent = next; w.classList.remove('is-out'); void w.offsetWidth; w.classList.add('is-in');
        box.style.width = measure(next) + 'px';
        setTimeout(function () { box.style.width = ''; }, 500);
      }, 400);
      setTimeout(step, 3200);
    };
    setTimeout(step, 2600);
  }

  function boot() {
    var hs = document.querySelectorAll('[data-cycle]'); if (!hs.length) return;
    if (!document.getElementById('cyc-css')) { var s = document.createElement('style'); s.id = 'cyc-css'; s.textContent = CSS; document.head.appendChild(s); }
    hs.forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
